import { forwardRef } from 'react'

import TextareaAutosize from 'react-textarea-autosize'
import { styled } from 'styled-components'

import useAsyncOnChange from './useAsyncOnChange'

const StyledTextarea = styled(TextareaAutosize)`
  display: block;
  border: 1px solid ${(p) => p.theme.border};
  border-radius: 4px;
  background-color: ${(p) => p.theme.background};
  padding: 8px 12px;
  width: ${(p) => p.width};
  resize: none;
  line-height: 1.5;
  color: ${(p) => p.theme.text};

  &:disabled {
    border-color: ${(p) => p.theme.border};
    color: ${(p) => p.theme.mutedText};
  }

  &:focus {
    border-color: ${(p) => p.theme.highlight};
    box-shadow: none;
  }
`

const RawTextarea = forwardRef((props, ref) => {
  const { value, onChange, onFocus, onBlur } = useAsyncOnChange(props)

  return (
    <StyledTextarea
      {...props}
      ref={ref}
      onChange={(e) => onChange(e.target.value)}
      value={value || ''}
      spellCheck='false'
      onFocus={onFocus}
      onBlur={onBlur}
    />
  )
})

RawTextarea.displayName = 'RawTextarea'
export default RawTextarea
